import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 审核按钮 */
const ExamineButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

ExamineButton.defaultProps = {
  icon: ICON_COLLECTION.EXAMINE,
  text: '审核',
};

export default ExamineButton;
